export const GET_SUSPENDED_USER = 'GET_SUSPENDED_USER'
export const GET_SUSPENDED_USER_RES = 'GET_SUSPENDED_USER_RES'
export const SUSPENDED_RES_STATUS = 'SUSPENDED_RES_STATUS'

export const GET_BLOCKED_USER = 'GET_BLOCKED_USER'
export const GET_BLOCKED_USER_RES = 'GET_BLOCKED_USER_RES'
export const BLOCKED_RES_STATUS = 'BLOCKED_RES_STATUS'